module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/img-4-8963dcabd01f51862f3fd14796699a49.png";